import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_portal-category_page_brand_tile-click';

/**
 * an event emitted when a retailer clicks a brand tile on the category page. TileType denotes whether the brand tile is displaying a brand story ("BRAND_STORY"), review ("REVIEW"), or empty ("EMPTY")
 */
export function trackRetailerPortalCategoryPageBrandTileClick(
  _tileType: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { _tileType },
  });
}
